module.exports = __webpack_public_path__ + "media/youreBack2.fefe0cd2.mp3";